import React from 'react';

type ObjProps = {
  label: string;
  onPress: () => void;
};
interface TabProps {
  activeTab: string;
  obj: ObjProps[];
  activeKey?: string | null;
}

const Tabs = (props: TabProps) => {
  const { obj, activeTab, activeKey } = props;

  const onClickTab = (onPress: () => void) => {
    if (activeKey !== undefined) {
      onPress();
    }
  };

  return (
    <div
      data-testid="tabs-wrapper"
      className={`rounded-sm h-[41px] w-full flex text-sm flex-row items-center text-center border-b ${
        activeKey === undefined ? 'bg-[#cecdcd]' : 'bg-[#569DAA] '
      }`}
    >
      {obj.map((item: ObjProps, index: number) => {
        return (
          <div
            data-testid="onClicktab"
            key={index}
            onClick={() => onClickTab(item.onPress)}
            className={`mr-2 font-semibold  h-[42px] w-fit flex items-center px-2 sm:px-4 text-sm ${
              activeTab === item.label
                ? `border-x-2 border-t  bg-white text-[#27374d] rounded-tl-sm rounded-tr-sm`
                : 'text-white'
            } ${activeKey !== undefined && 'cursor-pointer'}`}
          >
            <div className="text-[14px]" data-testid={`label-index-${index}`}>
              {item.label}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Tabs;
